import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import SidebarItem from '../features/SidebarItem.jsx';
import { LanguageLoader } from '../../assets/languages/index.js';

const Sidebar = ({status}) => {
	const settings = useSelector((state) => state.settings);
	const user = useSelector((state) => state.current_user);
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	return (
		<aside className={(status === 'collapse' ? 'hidden' : '')}>
			<Link className="flex flex-wrap items-center justify-between mt-7 mb-4 px-5 z-10" to="/" rel="noreferrer">
				{settings.portal_title && settings.portal_title !== '' ? (
					<span className="w-full text-xs text-primary md:text-secondaryFont mb-2">{settings.portal_title}</span>
				) : (
					<>
						<span className="w-full text-xs text-primary md:text-secondaryFont mb-2">{language.PORTAL_HEADER}</span>
						{settings.company_name ? <span className="w-full text-sm text-primary md:text-secondaryFont">{settings.company_name}</span> : null}
					</>
				)}
			</Link>
			<div className="z-10 h-px bg-gradient-to-r from-transparent via-black md:via-gray to-transparent mb-6 "></div>
			<div className="side-navigation z-10 px-2">
				{Object.values(settings.routes).map((item, index) => {
					if(item.hidden === 'always' || (item.hidden === 'loggedIn' && user.id) || (item.hidden === 'loggedOut' && !user.id))
					{
						return null;
					}
					return <SidebarItem key={index} {...item}/>
				})}
			</div>
		</aside>
	)
}

export default Sidebar;